import { Button, CircularProgress, FormControl, Grid, InputLabel, Modal, Select, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { achilliServer } from '../../../network'
import { Autocomplete } from '@material-ui/lab'
import axios from 'axios'

const ModalForPatientsFile = ({ visible, setVisible, onUpload }) => {
    const [openPatientDD, setOpenDD] = useState(false)
    const [loading, setLoading] = useState(false)
    const [options, setOptions] = useState([])
    const [patientName, setPatientName] = useState('')
    const [patientId, setPatientId] = useState('')
    const [amputations, setAmputations] = useState([])
    const [selectedAno, setAno] = useState('')
    const [selectedDno, setDno] = useState('')
    const [lastDNO, setLastDNO] = useState()
    const [dnos, setDnos] = useState([])
    const [cadFiles, setFiles] = useState([])
    const [selectedFile, setSelectedFile] = useState('')

    const getPatients = async (e) => {
        setPatientName(e.target.value)
        setLoading(true)
        const res = await achilliServer.post('/editor/list/patient/?page=1&limit=40', { patient_name: e.target.value })
        setOptions(res?.data?.patients)
        setAmputations([])
        setDnos([])
        setSelectedFile('')
        setFiles([])
        setLoading(false)
    }

    const setPatientAndGetAno = async (e, value) => {
        setPatientId(value.pk)
        const res = await achilliServer.get(`/editor/${value.pk}/amp/0/info/`)
        setAmputations(res?.data?.all_amputations)
        setLastDNO(res?.data?.last_dno)
        setDnos([])
        setFiles([])
    }

    const setAnoAndGetDno = async (e) => {
        setAno(e.target?.value)
        const getDnos = await achilliServer.get(`/editor/dgns/stump/${patientId}/${e?.target?.value}/${lastDNO}/`)
        setDnos(getDnos?.data?.all_diagnosis)
    }

    const setDnoAndGetFile = async (e) => {
        setDno(e?.target?.value)
        const files = await achilliServer.get(`/editor/manu/test/${patientId}/${selectedAno}/${e.target?.value}/`)
        setFiles(files?.data?.s3_files?.cad)
    }

    const useFileForModelling = async () => {
        const fetchFileFromS3 = await axios.get(selectedFile, { responseType: 'blob' })
        const file = new File([fetchFileFromS3.data], 'sample-file.ply')
        const fakeEvent = {
            target: {
                files: [file]
            }
        }
        onUpload(fakeEvent)
        setVisible(false)
    }

    return (
        <Modal
            open={visible}
            onClose={() => setVisible(false)}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            aria-labelledby="achilli-form"
            aria-describedby="achilli-data-builder"
        ><Grid container spacing={2} style={{ width: '50%', background: 'rgb(89 86 86 / 77%)', padding: 10, borderRadius: 8 }}>
                <Grid item xs={6}>
                    <Autocomplete
                        id="patients"
                        open={openPatientDD}
                        onOpen={() => {
                            setOpenDD(true);
                        }}
                        onClose={() => {
                            setOpenDD(false);
                        }}
                        onChange={(e, value) => setPatientAndGetAno(e, value)}
                        getOptionSelected={(option, value) => option.patient_name === value.patient_name}
                        getOptionLabel={(option) => option.patient_name}
                        options={options}
                        loading={loading}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Patient Name"
                                variant="outlined"
                                value={patientName}
                                onChange={e => getPatients(e)}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6}><FormControl style={{ width: '100%' }} variant="outlined">
                    <InputLabel htmlFor="filled-age-native-simple">Select Amputation</InputLabel>
                    <Select
                        native
                        value={selectedAno || ''}
                        onChange={(e) => setAnoAndGetDno(e)}
                        inputProps={{
                            name: 'ano',
                            id: 'amp-selection',
                        }}
                        key={JSON.stringify(amputations)}
                    >
                        <option value=''>Select</option>
                        {amputations?.map(amp => <option key={amp?.no} value={amp?.no}>{`${amp?.no} (${amp?.side_name} ${amp?.pro_type_name})`}</option>)}
                    </Select>
                </FormControl></Grid>
                <Grid item xs={6}><FormControl style={{ width: '100%' }} variant="outlined">
                    <InputLabel htmlFor="filled-age-native-simple">Select Diagnosis</InputLabel>
                    <Select
                        native
                        value={selectedDno || ''}
                        onChange={(e) => setDnoAndGetFile(e)}
                        inputProps={{
                            name: 'ano',
                            id: 'amp-selection',
                        }}
                        key={JSON.stringify(dnos)}
                    >
                        <option value=''>Select</option>
                        {dnos?.map(dno => <option key={dno?.dno} value={dno?.dno}>{`${dno?.dno} (${dno?.pro_type})`}</option>)}
                    </Select>
                </FormControl></Grid>
                <Grid item xs={6}><FormControl style={{ width: '100%' }} variant="outlined">
                    <InputLabel htmlFor="filled-age-native-simple">Test Sockets</InputLabel>
                    <Select
                        native
                        value={selectedFile || ''}
                        onChange={(e) => setSelectedFile(e?.target?.value)}
                        inputProps={{
                            name: 'Socket File',
                            id: 'file-selection',
                        }}
                        key={JSON.stringify(cadFiles)}
                    >
                        <option value=''>Select</option>
                        {cadFiles?.map(file => <option key={file?.key} value={file?.object_url}>{file?.file_name}</option>)}
                    </Select>
                </FormControl></Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 5 }}>
                    <Button onClick={() => setVisible(false)} variant="outlined" color='primary'>Cancel</Button>
                    <Button disabled={!selectedFile} onClick={useFileForModelling} variant="outlined" color='primary'>Fetch</Button>
                </Grid>
            </Grid>
        </Modal >
    )
}

export default ModalForPatientsFile